import React from "react";
import { InputText } from "primereact/inputtext";

const CodeInput = ({ regCode, handleChange, isValid }) => {
  return (
    <div className='p-field k-mb-2r'>
      <span className='p-float-label'>
        <InputText
          name='regCode'
          value={regCode}
          onChange={handleChange}
          className={!isValid && "p-invalid"}
        />
        <label htmlFor='regCode'>Administrator Registration Code</label>
      </span>
    </div>
  );
};

export default CodeInput;
